module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1379.428d3718.jpg";